<template>
  <div class="teaser-big-image-slider-element-fi">
    <teaser-big-image-element-fi
      :fields="fields"
      :is-slider-element="true"
      :pause-video="slideChanged"
    />
  </div>
</template>

<script>
import TeaserBigImageElementFi from '@/components/teaser/teaser-big-image-element-fi/TeaserBigImageElementFi.vue';

export default {
  name: 'TeaserBigImageSliderElementFi',
  components: {
    TeaserBigImageElementFi,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    slideChanged: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
